import React, { useRef, useEffect, useState } from "react";
import grapesjs from "grapesjs";
import "grapesjs/dist/css/grapes.min.css";
import "./GrapesEditor.css";
import { triggerNotification } from "../../component/message/Msg";
import config from "../../config";
import { useLocation, useParams } from 'react-router-dom';
import "grapesjs-blocks-basic";
// import "@lottiefiles/lottie-player";

function GrapesJSEditor({ editorId, blocksId, onSave, text }) {
  const editorRef = useRef(null);
  const [selectedBlock, setSelectedBlock] = useState(null); // track the selected block
  const [showAddButtons, setShowAddButtons] = useState(false); // track whether to show the add buttons
  const [showTextImageLinkBlocks, setShowTextImageLinkBlocks] = useState(true); // control visibility of Text, Image, Link blocks
  const [isOpen, setIsOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [selectedMcqBank, setSelectedMcqBank] = useState("");
  const [mcqBanks, setMcqBanks] = useState([]);
  const [loading, setLoading] = useState(false);
  const [sectionList, setSectionList] = useState([]);
  const [sectionValue, setSectionValue] = useState("");
  const [mcqMarks, setMcqMarks] = useState("");
  const [commonMcqMarks, setCommonMcqMarks] = useState("");
  const [commonNegativeMcqMarks, setCommonNagativeMcqMarks] = useState("");
  const [expainationFileVal, setExpainationFileVal] = useState([]);
  const [queFileVal, setQueFileVal] = useState([]);
  const [optFileVal, setOptFileVal] = useState([]);
  const [previousYear, setPreviousYear] = useState([]);
  const [negativeMarks, setNegativeMarks] = useState("");
  const [courseWiseQue, setCourseWiseQue] = useState(true);
  const [sectionData, setSectionData] = useState({});
  const [selectedMcqs, setSelectedMcqs] = useState([]);

  const [questions, setQuestions] = useState([]);
  const [timer, setTimer] = useState({
    set_timer: false,
    timer: "",
  });
  const [selectedMcqQuestions, setSelectedMcqQuestions] = useState([]);
  const [selectAllMcq, setSelectAllMcq] = useState(false);
  const [hasRemainingMcqs, setHasRemainingMcqs] = useState(true);
  const token = config.token;
  const optionHead = [
    "A",
    "B",
    "C",
    "D",
    "E",
    "F",
    "G",
    "H",
    "I",
    "J",
    "K",
    "L",
    "M",
    "N",
    "O",
    "P",
  ];

  const useQuery = () => {
    return new URLSearchParams(useLocation().search);
  };
  const query = useQuery();
  const from = query.get("type");

  const { base, id } =
    useParams();



  const fetchbank = () => {
    fetch(`${config.host_url}mcqbanks/chapter/${decodeURIComponent(atob(id))}`, {
      method: "GET",
      headers: { token },
    })
      .then((res) => res.json())
      .then((data) => setMcqBanks(data.data));
  };



  const handleSelectedMcqBank = (e) => {
    const selectedValue = e.target.value;
    setSelectedMcqBank(selectedValue);
    setQueFileVal([]);
    setOptFileVal([]);
    setSectionList([]);
    getQuestions(selectedValue); // Fetch questions for the selected bank
  };

  const getQuestions = async (id) => {
    if (id !== "") {
      setLoading(true);
      setQuestions([]);
      try {
        await fetch(`${config.host_url}mcq?mbid=${id}&from=mcq`, {
          method: "GET",
          headers: {
            token: token,
          },
        })
          .then((response) => response.json())
          .then((data) => {
            if (data.status === 200) {


              setQuestions(data.data);
              const sectionListData = data.sections.map((section, i) => ({
                section: section,
                esid: data.esid[i],
              }));
              setSectionList(sectionListData);
            } else if (data.status === 401) {
              triggerNotification("error", "Unauthenticated user");
            } else {
              triggerNotification(
                "error",
                "Internal server error, Please try after some time!!"
              );
            }
          });
      } catch (error) {
        triggerNotification("error", "Error fetching data");
      } finally {
        setLoading(false);
      }
    }
  };

  const handleCheckboxChange = (mcqId) => {
    setSelectedMcqs((prevSelectedMcqs) => {
      if (prevSelectedMcqs.includes(mcqId)) {
        return prevSelectedMcqs.filter((id) => id !== mcqId);
      } else {
        return [...prevSelectedMcqs, mcqId];
      }
    });
  };

  // const handleEditBtn = (mcqid, sec) => {
  //   const adfrom = upfrom;
  //   navigate(
  //     `/addmcq/${mcqid}/${id}/${base}/${adfrom}/sec/${sec}/mbid/${mcqBank.selectedBankId}?from=mcq`
  //   );
  // };

  const filteredMcqBanks = mcqBanks?.filter(mcqBank => {
    // const bankName = from === "mcq" ? mcqBank.bank_name : mcqBank.exam_name;
    return mcqBank.bank_name?.toLowerCase().includes(searchTerm.toLowerCase());
  });

  const basicClick = (e, id) => {
    e.preventDefault();

    addSelectedBlock(`<iframe src="https://deepvecto.com/api/singlemcq?id=${id}" ></iframe>`)

    // addSelectedBlock(`<section>${res.body}</section>`)
    //  addSelectedBlock(`<section></section>`)
    setIsOpen(false)

  }


  useEffect(() => {
    const initEditor = () => {
      if (editorRef.current) return;

      const editor = grapesjs.init({
        container: `#${editorId}`,
        height: "400px",
        components: text,
        components: components,
        storageManager: false,



      });

      // Add Lottie Component (lottie-player) to GrapesJS
    editor.DomComponents.addType('lottie-player', {
      model: {
        defaults: {
          tagName: 'lottie-player',
          attributes: {
            autoplay: true,
            controls: true,
            loop: true,
            mode: 'normal',
            src: 'https://assets3.lottiefiles.com/packages/lf20_UJNc2t.json', // Default animation URL
            style: 'width: 320px;', // Default width
          },
        },
      },
      view: {},
    });

    // Add Lottie Block to BlockManager for drag-and-drop functionality
    editor.BlockManager.add('lottie-player-block', {
      label: 'Lottie Animation',
      category: 'Media',
      content: {
        type: 'lottie-player',
        src: 'https://assets3.lottiefiles.com/packages/lf20_UJNc2t.json',  // Default URL for Lottie animation
      },
    });
    
  

      // Adding buttons to the editor panel
editor.Panels.addButton('options', [
  {
    id: 'clear-canvas',
    className: 'fa fa-trash',
    command: 'clear-canvas',
    attributes: { title: 'Clear Canvas' },
  },
  {
    id: 'undo',
    className: 'fa fa-undo',
    command: 'undo',
    attributes: { title: 'Undo' },
  },
  {
    id: 'redo',
    className: 'fa fa-redo',
    command: 'redo',
    attributes: { title: 'Redo' },
  },
  {
    id: 'save',
    className: 'fa fa-save',
    command: 'save-canvas',
    attributes: { title: 'Save Canvas' },
  },
]);

// Adding commands for the buttons
editor.Commands.add('clear-canvas', {
  run(editor) {
    editor.DomComponents.clear();
    editor.CssComposer.clear();
    editor.UndoManager.clear();
    editor.AssetManager.clear();
  },
});

editor.Commands.add('undo', {
  run(editor) {
    editor.UndoManager.undo();
  },
});

editor.Commands.add('redo', {
  run(editor) {
    editor.UndoManager.redo();
  },
});

// Adding save functionality
editor.Commands.add('save-canvas', {
  run(editor, sender) {
    // const blocksId = editor.get('components').toJSON();
    handleSave();
    if (sender) sender.set('active', false); // Optional: Deactivate the button after saving
  },
});

// Save button function



      
      

      editor.on('block:drag:stop', (component) => {
        console.log(component['attributes']['attributes']['data-type']);

        // Check if the dragged component has the correct `data-type` attribute
        if (component && component['attributes']['attributes']['data-type'] == 'MCQ') {
          const view = component.view;
          const el = view.el; // Get the DOM element of the component
          console.log(view);
          console.log(el);
          setIsOpen(true);
          fetchbank();
          // Add a click event listener
          el.addEventListener('click', () => {

          });

          // Optional: Add a class or attribute to indicate the event is bound
          component.addAttributes({ 'data-event-bound': 'true' });
        }
      });


      // Single Column Block
      // Add Single Column Block with Icon
      editor.BlockManager.add('single-column-block', {
        label: `
    <div style="display: flex; flex-direction: column; align-items: center; color: white;">
      <div style="font-size: 24px; font-weight: bold;">&#9632;</div> <!-- Icon -->
      <div>1 Column</div>
    </div>
  `,
        content: `
    <div class="single-column-block" style="display: flex; flex-direction: column; box-sizing: border-box; height: 100px; margin: 10px 0; padding: 10px; border: 1px solid #ddd;">
      <div style="flex: 1; width: 100%; text-align: center;">
        Single Column Content
      </div>
    </div>
  `,
        category: 'Basic',
        select: true,
        activate: true,
        draggble: false
      });
      // Add Double Column Block with Icon
      editor.BlockManager.add('double-column-block', {
        label: `
    <div style="display: flex; flex-direction: column; align-items: center; color: white;">
      <div style="font-size: 24px; font-weight: bold;"><i class="fa-solid fa-table-columns"></i></div> <!-- Icon -->
      <div>2 Columns</div>
    </div>
  `,
        content: `
    <div class="double-column-block" style="display: flex; box-sizing: border-box; height: 100px; margin: 10px 0; padding: 10px; border: 1px solid #ddd;">
      <div style="flex: 1; text-align: center; padding: 5px; border-right: 1px solid #ddd;">
        Column 1
      </div>
      <div style="flex: 1; text-align: center; padding: 5px;">
        Column 2
      </div>
    </div>
  `,
        category: 'Basic',
      });
      editor.BlockManager.add('bullet-list', {
        label: `
    <div style="display: flex; flex-direction: column; align-items: center; color: white;">
      <div style="font-size: 24px; font-weight: bold;">&#8226;</div> <!-- Bullet icon -->
      <div>Bullet</div>
    </div>
  `,
        content: `
    <ul style="padding-left: 20px;">
      <li>Bullet item 1</li>
      <li>Bullet item 2</li>
      <li>Bullet item 3</li>
    </ul>
  `,
        category: 'Basic',
      });
      // Numbering List Block
      editor.BlockManager.add('numbering-list', {
        label: `
    <div style="display: flex; flex-direction: column; align-items: center; color: white;">
      <div style="font-size: 24px; font-weight: bold;">1.</div> <!-- Numbering icon -->
      <div>Numbering</div>
    </div>
  `,
        content: `
    <ol style="padding-left: 20px;">
      <li>Numbered item 1</li>
      <li>Numbered item 2</li>
      <li>Numbered item 3</li>
    </ol>
  `,
        category: 'Basic',
      });
      // Section Block
      editor.BlockManager.add('section-block', {
        label: `
    <div style="display: flex; flex-direction: column; align-items: center; color: white;">
      <div style="font-size: 24px; font-weight: bold;">&#9632;</div> <!-- Section icon -->
      <div>Section</div>
    </div>
  `,
        content: `
    <section style="padding: 20px; border: 1px solid #ddd; margin: 10px 0;">
      <h2>Section Title</h2>
      <p>This is a section block. Add your content here.</p>
    </section>
  `,
        category: 'Basic',
      });
      // Text Block
      editor.BlockManager.add('text-block', {
        label: `
    <div style="display: flex; flex-direction: column; align-items: center; color: white;">
      <div style="font-size: 24px; font-weight: bold;">T</div> <!-- Text icon -->
      <div>Text</div>
    </div>
  `,
        content: `
    <p style="margin: 10px 0;">This is a text block. You can edit this text.</p>
  `,
        category: 'Basic',
      });
      // Link Block
      editor.BlockManager.add('link-block', {
        label: `
    <div style="display: flex; flex-direction: column; align-items: center; color: white;">
      <div style="font-size: 24px; font-weight: bold;"><i class="fa-solid fa-link"></i></div> <!-- Link icon -->
      <div>Link</div>
    </div>
  `,
        content: `
    <a href="#" style="color: blue; text-decoration: underline;">This is a link</a>
  `,
        category: 'Basic',
      });
      // List Block
      editor.BlockManager.add('list-block', {
        label: `
    <div style="display: flex; flex-direction: column; align-items: center; color: white;">
      <div style="font-size: 24px; font-weight: bold;">&#9776;</div> <!-- List icon -->
      <div>List</div>
    </div>
  `,
        content: `
    <ul style="padding-left: 20px;">
      <li>List item 1</li>
      <li>List item 2</li>
      <li>List item 3</li>
    </ul>
  `,
        category: 'Basic',
      });
      // Image Block
      editor.BlockManager.add('image-block', {
        label: `
    <div style="display: flex; flex-direction: column; align-items: center; color: white;">
      <div style="font-size: 24px; font-weight: bold;"><i class="fa-solid fa-image"></i></div> <!-- Image icon -->
      <div>Image</div>
    </div>
  `,
        content: `
    <img src="https://via.placeholder.com/150" alt="Placeholder Image" style="width: 100%; max-width: 150px;"/>
  `,
        category: 'Basic',
      });
      editor.BlockManager.add('MCQ', {
        label: `
        <div style="display: flex; flex-direction: column; align-items: center; color: white;">
          <div style="font-size: 24px; font-weight: bold;"><i class="fa-solid fa-newspaper"></i></div> <!-- Icon -->
          <div>MCQ</div>
        </div>
      `,
        content: {
          tagName: 'span',
          draggable: true,
          droppable: true,
          attributes: { class: 'my-block margin-only', 'data-type': 'MCQ' },
          style: 'box-sizing: border-box; height: 100px; margin: 10vh 0 0 0; text-align: center;',
          components: '', // Text inside the block
        },
        category: 'Extra',
      });
      editor.on('load', () => {
        console.log(editor.Panels)
        editor.runCommand('open-blocks') 
        // const categories = editor.BlockManager.getCategories();
        // // console.log(categories[0]);
        
        // const defaultCategory = categories.find(cat=> cat.id=="Extra")
        // defaultCategory.set('open', true);
      
        // if (defaultCategory) {
        // }
      });



      editorRef.current = editor;

      editor.on("component:selected", (model) => {
        // Check if the selected component is a column (gjs-col)
        if (model?.getClasses().includes("gjs-col")) {
          setSelectedBlock(model); // store the selected column
          setShowAddButtons(true);  // show the add block buttons
          setShowTextImageLinkBlocks(false); // hide text, image, and link blocks when a column is selected
        } else {
          setShowAddButtons(false); // hide the add block buttons when not a column
          setSelectedBlock(null); // reset the selected block
          setShowTextImageLinkBlocks(true); // show text, image, and link blocks when a column is not selected
        }

      });
    };

    initEditor();
    // setInterval(() => {
    //   const html = editorRef.current.getHtml();
    // const css = editorRef.current.getCss();
    // onSave({ html, css });

    // }, 10000); 


  }, [editorId, blocksId, text, showTextImageLinkBlocks]);

  // Function to add content to the selected column or body (if no column is selected)
  const addSelectedBlock = (blockContent) => {
    if (selectedBlock) {
      selectedBlock.append(blockContent);
      // triggerNotification("success", `${blockContent} added to the column`);
    } else {
      // If no column is selected, add the block directly to the body of the page
      const body = editorRef.current?.getComponents();
      if (body) {
        body.add(blockContent); // Add block to the body
        // triggerNotification("success", `${blockContent} added to the body`);
      } else {

        alert("Unable to add block.");
      }
    }
  };

  // Handle save action
  const handleSave = (blocksId) => {
    const html = editorRef.current.getHtml();
    const css = editorRef.current.getCss();
    onSave({ html, css });
    // if (blocksId) {
      triggerNotification("success", "Successfully saved");
    // } else {

    // }

  };

  // Handle clear action
  const handleClear = () => {
    editorRef.current?.setComponents([]);
  };

  // Add Bullets to selected component
  const addBullets = () => {
    const selected = editorRef.current?.getSelected();
    if (selected) {
      selected.replaceWith(`<ul><li>${selected.toHTML()}</li></ul>`);
    } else {
      alert("Please select a component to add bullets.");
    }
  };

  // Add Numbering to selected component
  const addNumbering = () => {
    const selected = editorRef.current?.getSelected();

    if (!selected) {
      alert("Please select a component to add numbering.");
      return;
    }

    // Get all child components of the selected element
    const childComponents = selected.components();

    if (childComponents.length > 0) {
      // If the selected element has child components
      const numberedList = childComponents
        .map((child) => `<li>${child.toHTML()}</li>`)
        .join("");

      // Replace the selected element's content with an ordered list
      selected.components(`<ol>${numberedList}</ol>`);
    } else {
      // If no child components, wrap the selected element itself
      const parent = selected.parent();
      const siblings = parent?.components();

      if (siblings) {
        // Get all sibling elements to form one ordered list
        const numberedList = siblings
          .map((sibling) => `<li>${sibling.toHTML()}</li>`)
          .join("");

        // Replace parent content with an ordered list
        parent.components(`<ol>${numberedList}</ol>`);
      } else {
        // If no siblings, apply numbering to the selected element only
        selected.replaceWith(`<ol><li>${selected.toHTML()}</li></ol>`);
      }
    }
  };


  const components = `<div>Some initial components</div>`;

  return (
    <>

      <div id={editorId} style={{ height: "400px", border: "1px solid #ccc", marginBottom:"30px" }}></div>
      {/* <div
        id={blocksId}
        className="block-container"
        style={{
          marginBottom: "30px",
          display: "flex",
          flexWrap: "nowrap",   // Ensure all items are in a single row
          gap: "15px",
          justifyContent: "flex-start",
          // overflowX: "scroll",    // Add horizontal scrolling if the blocks overflow horizontally
          whiteSpace: "nowrap", // Prevent wrapping of buttons and blocks to the next line
        }}
      >
        <button type="button" onClick={() => handleSave(blocksId)} className="action">Save</button>
        <button type="button" onClick={handleClear} className="action">Clear</button>
        <button type="button" onClick={addBullets} className="action">Bullets</button>
        <button type="button" onClick={addNumbering} className="action">Numbering</button> 

        <div className="add-block-buttons" style={{ display: "inline-block" }}>
          <button
            type="button"
            onClick={() => addSelectedBlock('<section><h1>Section Title</h1><div>Section Content</div></section>')}
            className="action-button"
          >
            Section
          </button>
          <button
            type="button"
            onClick={() => addSelectedBlock('<div data-gjs-type="text">Insert your text here</div>')}
            className="action-button"
          >
            Text
          </button>
          <button
            type="button"
            onClick={() => addSelectedBlock('<a href="#">Link</a>')}
            className="action-button"
          >
            Link
          </button>
          <button
            type="button"
            onClick={() => addSelectedBlock('<ul><li>List Item 1</li><li>List Item 2</li></ul>')}
            className="action-button"
          >
            List
          </button>
          <button
            type="button"
            onClick={() => addSelectedBlock('<img src="#" alt="Image">')}
            className="action-button"
          >
            Image
          </button>
          <button
            type="button"
            onClick={() => {
              setIsOpen(true);
              fetchbank();
            }}
            className="action-button"
          >
            Mcq
          </button>
        </div>*/}
      {isOpen && (
        <div className="popup-overlay">
          <div className="popup-content">
            <div className="flex justify-between">
              <h2>Select MCQ</h2>

              <span onClick={() => setIsOpen(false)} className="close-icon text-3xl cursor-pointer">&times;</span>

            </div>
            <div className="col-md-12 mt-2">
              <div className="form-floating form-floating-outline mb-4">

                <div
                  className="form-select w-100 mx-auto"
                  onClick={() => {
                    setIsDropdownOpen(!isDropdownOpen);
                  }}
                  style={{ cursor: "pointer", textAlign: selectedMcqBank ? "left" : "center" }}
                >
                  {selectedMcqBank ? (
                    mcqBanks.find(bank => bank.mbid === selectedMcqBank)?.bank_name || "--- Select MCQ Bank ---"
                  ) : "--- Select MCQ Bank ---"}
                </div>
                <label className="position-absolute" style={{ top: "-1px", left: "-1px" }}>
                  MCQ Banks
                </label>

                {isDropdownOpen && (
                  <div className="dropdown-menu show w-100" style={{ maxHeight: "200px", overflowY: "auto" }}>
                    <input
                      type="text"
                      className="form-control p-2"
                      placeholder="Search MCQ Banks"
                      value={searchTerm}
                      onChange={(e) => setSearchTerm(e.target.value)}
                      style={{
                        margin: '8px 20px 8px 5px',
                        width: '95%',
                      }}
                    />
                    <ul className="list-unstyled p-2 w-100">
                      {filteredMcqBanks?.map((mcqBank) => (
                        <li
                          key={mcqBank.mbid}
                          className="dropdown-item w-100"
                          onClick={() => {
                            handleSelectedMcqBank({ target: { value: mcqBank.mbid } });
                            setIsDropdownOpen(false); // Close dropdown after selection
                          }}
                        >
                          {mcqBank.bank_name}
                        </li>
                      ))}
                      {filteredMcqBanks.length === 0 && (
                        <li className="dropdown-item text-muted w-100">No MCQ Banks found</li>
                      )}
                    </ul>
                  </div>
                )}
              </div>
            </div>
            {sectionList && sectionList.length > 0 ? (
              <div className="card mb-4">
                <div className="card-header p-0">
                  <div className="nav-align-top">
                    <ul className="nav nav-tabs" role="tablist">
                      {sectionList.map((section, i) => (
                        <li className="nav-item" key={i}>
                          <button
                            type="button"
                            className={`nav-link ${i === 0 && "active"} `}
                            role="tab"
                            data-bs-toggle="tab"
                            data-bs-target={`#navs-top-${section.section}`}
                            aria-controls={`navs-top-${section.section}`}
                            aria-selected={i === 0 ? "true" : "false"}
                          >
                            {section.section}


                          </button>
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
                <div className="card-body">
                  <div className="tab-content p-0">
                    {sectionList.map((section, index) => (
                      <div
                        key={index}
                        className={`tab-pane fade ${index === 0 && "show active"
                          } `}
                        id={`navs-top-${section.section}`}
                        role="tabpanel"
                      >

                        {questions[section.section]
                          ?.filter((question) => question.que_type === "Single Choice" || question.que_type === "True/False") // Filter questions by type
                          .map((question, i) => (
                            <div key={i}>
                              <div className="flex item-center">
                                <div style={{ marginLeft: "0px" }}>

                                </div>
                                <label htmlFor={`customCheckboxMcq${i}`}>
                                  <h5 className="select-none">
                                    {i + 1}.{" "}
                                    {question.isFormula === 1 ? (
                                      // <Latex>{ question?.que}</Latex>
                                      <>
                                        <math-field disabled>
                                          {" "}
                                          {question.que}
                                        </math-field>
                                      </>
                                    )
                                      : !question.que_file == 'undefined' ? (
                                        <div className="mt-2">
                                          <img
                                            src={question.que_file}
                                            alt="Uploaded file"
                                            className="img-fluid"
                                            style={{ maxWidth: '100%', height: 'auto' }}
                                          />
                                        </div>
                                      )
                                        : (
                                          question.que.replace(
                                            /\{dash\}/g,
                                            "__________"
                                          )
                                        )}
                                  </h5>
                                </label>

                              </div>


                              {question.explanation && (
                                <div className="flex select-none ml-14 ">
                                  <h6 className="mr-2">Explanation :</h6>
                                  <h6 className="text-slate-950/50">
                                    {question.explanation}
                                  </h6>
                                </div>
                              )}


                              {question.explanation_file && (
                                <div className="flex select-none ml-14 ">
                                  <h6 className="mr-2">
                                    {"Explanation File :"}
                                  </h6>
                                  <h6 className="text-slate-950/50">
                                    <a
                                      href={question.explanation_file}
                                      target="_blank"
                                      rel="noopener noreferrer"
                                      className=" border px-1 bg-gray-100 rounded shadow-sm text-blue-400"
                                    >
                                      Open
                                    </a>
                                  </h6>
                                </div>
                              )}





                              <div className="ml-14">
                                <div className="row">
                                  {(question.options && question.options.length > 0) || (question.options_file && question.options_file.length > 0) ? (
                                    <>
                                      {question.options && question.options.length > 0 && question.options.every(option => ["a", "b", "c", "d"].includes(option)) ? (
                                        question.options_file && question.options_file.length > 0 && question.options_file.map((option, j) => (
                                          <div className="col-md-6 flex pr-28" key={j}>
                                            <span className="mr-2 pb-0 mb-0">
                                              {optionHead[j]} {") "}
                                            </span>
                                            <span className="flex flex-column">
                                              <img
                                                src={option}
                                                alt={`Option File ${j}`}
                                                className="img-fluid mb-1"
                                                style={{ maxWidth: '100%', height: 'auto' }}
                                              />
                                            </span>
                                          </div>
                                        ))) : (
                                        question.options.map((option, j) => (
                                          <div className="col-md-6 flex pr-28" key={j}>
                                            <span className="mr-2 pb-0 mb-0">
                                              {optionHead[j]} {") "}
                                            </span>
                                            <span className="flex flex-column">
                                              <span>{option.text || option}</span>
                                            </span>
                                          </div>
                                        ))
                                      )}
                                      {!(question.options && question.options.length > 0 && question.options.every(option => ["a", "b", "c", "d"].includes(option))) &&
                                        question.options_file && question.options_file.length > 0 && question.options_file.map((option, j) => (
                                          option.options_file ? (
                                            <div className="col-md-6 flex pr-28" key={j}>
                                              <span className="mr-2 pb-0 mb-0">
                                                {optionHead[j]} {") "}
                                              </span>
                                              <span className="flex flex-column">
                                                <img
                                                  src={option.options_file}
                                                  alt={`Option File ${j}`}
                                                  className="img-fluid mb-1"
                                                  style={{ maxWidth: '100%', height: 'auto' }}
                                                />
                                                <span>{option.text || "No description available"}</span>
                                              </span>
                                            </div>
                                          ) : null
                                        ))
                                      }
                                    </>
                                  ) : (
                                    <p>No options available</p>
                                  )}
                                  <span className="flex pl-0">
                                    <h6 className="mr-2">Answer :</h6>
                                    <h6 className="text-slate-950/50">
                                      {question.que_type === "Match the pair"
                                        ? question.ans
                                          .replace(/\@\#\$/g, " => ")
                                          .replace(/\$\#\@/g, " | ")
                                        : question.ans.replace(/\@\#\$/g, ", ")}
                                    </h6>

                                  </span>
                                  <button onClick={(e) => basicClick(e, question.mcqid)} className="col-md-2 w-10 px-4 py-2 bg-blue-500 text-white font-bold rounded-lg hover:bg-blue-700 focus:outline-none">
                                    select
                                  </button>

                                </div>
                              </div>
                              <hr />
                            </div>
                          ))}

                      </div>
                    ))}
                  </div>
                </div>
              </div>
            ) : mcqBanks.selectedBankId ? (
              <p className="text-center">
                There are currently no questions available within this
                question bank.
              </p>
            ) : (
              <p className="text-center">
                Please choose a question bank to view its associated
                questions.
              </p>
            )}

          </div>
        </div>
      )}
      {/* </div>  */}
    </>
  );
}

function GrapesEditorApp({ onSave, components, index }) {

  return (
    <>
      <div>
        <GrapesJSEditor
          editorId={`gjs-${index}`}
          blocksId={`blocks-${index}`}
          onSave={onSave}
          text={components}

        // isOpen={isOpen}
        // setIsOpen={setIsOpen}
        // fetchbank={fetchbank}
        // basicClick={basicClick}
        />
      </div>
      <lottie-player
  autoplay
  controls
  loop
  mode="normal"
  src="https://assets3.lottiefiles.com/packages/lf20_UJNc2t.json"
  style={{width: '320px'}}
>
</lottie-player>
    </>
  );
}

export default GrapesEditorApp;
